"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _Icon = _interopRequireDefault(require("@cimpress/react-components/lib/Icon"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background: none;\n  border: none;\n  height: 30px;\n  padding: 0;\n  width: 30px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var buttonStyle = (0, _emotion.css)(_templateObject());

var ToolbarButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ToolbarButton, _PureComponent);

  function ToolbarButton() {
    (0, _classCallCheck2.default)(this, ToolbarButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ToolbarButton).apply(this, arguments));
  }

  (0, _createClass2.default)(ToolbarButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          title = _this$props.title,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled;

      var button = _react.default.createElement("button", {
        className: buttonStyle,
        style: {
          cursor: disabled ? 'not-allowed' : 'inherit'
        },
        title: title,
        type: "button",
        onClick: onClick,
        disabled: disabled
      }, _react.default.createElement(_Icon.default, {
        color: colors.shale,
        name: icon,
        size: "lg"
      }));

      return button;
    }
  }]);
  return ToolbarButton;
}(_react.PureComponent);

exports.default = ToolbarButton;
(0, _defineProperty2.default)(ToolbarButton, "defaultProps", {
  title: ''
});
(0, _defineProperty2.default)(ToolbarButton, "propTypes", {
  icon: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  tooltip: _propTypes.default.string,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool
});